export type Debounced<Args extends unknown[]> = ((...args: Args) => void) & { cancel: () => void };

export function debounce<Args extends unknown[]>(
  fn: (...args: Args) => void,
  waitMs: number,
): Debounced<Args> {
  let timer: ReturnType<typeof setTimeout> | null = null;
  const cancel = () => {
    if (timer !== null) clearTimeout(timer);
    timer = null;
  };
  const debounced = (...args: Args) => {
    cancel();
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, waitMs);
  };
  return Object.assign(debounced, { cancel });
}
